import { Col, Form, Input, InputNumber, Radio, RadioChangeEvent, Row, Select, Upload } from 'antd';
import { useEffect, useRef, useState, } from 'react'
import AntDraggableModal from '../../../utils/extend/AntDraggableModal';
import WebEditUniversal, { WEUExtendPropsType } from '../../system/WebEditUniversalNewEx';
import getList from '../../universal/getList';
import fetchApi from '../../../utils/api/fetchApi';
import systemExpand from '../../../config/systemExpand';
import FilesManage from '../../filesSystem/FilesManage';




export default function BuyerProudctEdit(props: any) {
    const [form] = Form.useForm(); //form 
    const { data } = props;
    const ref = useRef<any>(undefined);
    const [imageUrl, setImageUrl] = useState<string>();

    const [productData, setProductData] = useState<any>();
    const [bb, setBa] = useState<any>();

    const handleOk = (e: any) => {
        ref.current.handleOk();
    };
  const returnBackData = (data: any) => {        
        form.setFieldValue("productCertificateUrl", data.data.destination+"/"+ data.data.fileName)
    }
    const uploadButton = (
        <div>

            <div style={{ marginTop: 8 }}>产品合格证</div>
        </div>
    );
    const handleCancel = (e: any) => {


        ref.current.handleCancel();
    };


    /** 后端数据wmService */
    let wmService: any = "";
    let extendProps: WEUExtendPropsType = {
        ...props,
        form,
        apiId: 'buyerProuduct',

    };

    useEffect(() => {
        if (ref.current) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            wmService = ref.current.wmService;
            ref.current.row.then((res: any) => {
                if (typeof res === 'undefined') return;

                setImageUrl(res.data.productCertificateUrl)

            })
        }
        const fetchData = async () => {
            fetchApi.GET(wmService, {
                apiId: "product",
                apiExtend: 'showList',
                apiData: {
                    mountDataOptions: {
                        userMount: {
                            isDept: true,
                            isUserAreas: true
                        }
                    }
                }
            }).then(res => {
                console.log("res", res);

                setProductData(res.data)
            })

            let data = await systemExpand.filesServer2();
            const { apiServiceUrl, serviceId } = data;
            let uploadData = await FilesManage.upload(apiServiceUrl!, serviceId!, "documentLicenseFiles", { successCallback: returnBackData })
            setBa(uploadData)

        }
        fetchData()
    }, [])

    return (
        <>
            <WebEditUniversal ref={ref} props={extendProps}></WebEditUniversal>
            <AntDraggableModal
                title={(data.type === 'NEW' ? '新增' : '编辑') + '采购商产品'}
                open={true}
                okText='确定'
                cancelText='取消'
                onOk={handleOk}
                onCancel={handleCancel}
                closable={false}
                maskClosable={false}
                width={"70%"}
            >
                <Form
                    form={form}
                    name="Edit"
                    onFinish={handleOk}
                    onKeyDown={(e: any) => {
                        if (e.key === 'Enter') {
                            handleOk(e)
                        }
                    }}
                >
                    <Row >
                        <Col span={12}>
                            <Form.Item
                                label="id"
                                name="id">
                                <Input disabled />
                            </Form.Item>

                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label="产品"
                                name="productId"
                                rules={[{ required: true, message: '请输入产品!' }]}>
                                <Select
                                    showSearch

                                    placeholder="产品"
                                    optionFilterProp="children"
                                    onSearch={(e) => getList.search("product", setProductData, e, {
                                        "andWhereObj": {
                                            mountDataOptions: {
                                                "userMount": {
                                                    "isUserAreas": true,
                                                    "isDept": true
                                                }
                                            },
                                        }
                                    })}
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {getList.generalEx(productData, {
                                        "itemName": "productName", setItemNameFun: (item: any) => {
                                            return `${item.productName} ${item.productUnit.productUnitName}`;

                                        }
                                    })}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={12} >
                            <Form.Item
                                label="排序"
                                name="sortBy">
                                <InputNumber />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label=""
                                name="productCertificateUrl"

                            >
                                <Upload
                                    maxCount={1}
                                    {...bb}
                                    listType="picture-card"
                                >
                                    {imageUrl ? <img width={"100%"} src={imageUrl} alt="avatar" /> : uploadButton}
                                </Upload>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </AntDraggableModal>

        </>
    )
}


